var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01Home(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.03 13.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ea0029;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M613.07,957,608.26,954a1.2,1.2,0,0,0-1.29,0L602.15,957a1.18,1.18,0,0,0-.55,1v8.44a1.19,1.19,0,0,0,1.19,1.2h9.64a1.19,1.19,0,0,0,1.19-1.2V958A1.18,1.18,0,0,0,613.07,957Zm-7.71,9.79v-5.44a.26.26,0,0,1,.26-.26h4a.26.26,0,0,1,.26.26v5.44Zm7.43-.35a.37.37,0,0,1-.36.37h-1.74v-5.46a1.08,1.08,0,0,0-1.08-1.09h-4a1.09,1.09,0,0,0-1.09,1.09v5.46h-1.74a.37.37,0,0,1-.36-.37V958a.34.34,0,0,1,.17-.3l4.81-3.09a.36.36,0,0,1,.4,0l4.82,3.09a.35.35,0,0,1,.16.3Z",
    transform: "translate(-601.6 -953.76)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01Home);
export default __webpack_public_path__ + "static/media/01_Home.1f375a569db2014aa5dcb246c84e24b3.svg";
export { ForwardRef as ReactComponent };